'use client';

/**
 * Outcome-token send is now a thin variant of the unified send hook
 * (asset.kind === 'outcome_token'). This module exists for callers
 * still importing the named hook; new code should use `useSendGift`
 * directly and pass the asset envelope.
 */
import { c as _c } from "react/compiler-runtime";
import type BN from 'bn.js';
import { type SendGiftInput, type SendGiftResult, type UseSendGiftReturn, useSendGift } from './use-send-gift';
export class TransferFeeMintNotSupportedError extends Error {
  constructor(mint: string) {
    super(`outcome token mint ${mint} has a transfer fee extension; not supported`);
  }
}
export interface SendOutcomeTokenGiftInput {
  platform: 'morfi' | 'x';
  recipientHandle: string;
  message: string;
  anonymous: boolean;
  mintPubkey: string;
  amountBaseUnits: BN;
}
export type UseSendOutcomeTokenGiftReturn = UseSendGiftReturn;
export function useSendOutcomeTokenGift() {
  const $ = _c(5);
  const inner = useSendGift();
  let t0;
  if ($[0] !== inner) {
    t0 = async input => inner.submit(input);
    $[0] = inner;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== inner || $[3] !== t0) {
    t1 = {
      ...inner,
      submit: t0
    };
    $[2] = inner;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}